import { inlines } from './inlines';
export const heading = node => {
  let result = '';
  node.forEach(n => {
    result += inlines(n);
  });
  return `h${node.attrs.level}. ${result}`;
};